module.exports = __webpack_public_path__ + "img/03.a1251659.svg";